import store from '../store/index.js';

const axios = require('axios');

export default class AuthService {
  static getAccessToken(data) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'POST',
        url: '/auth/login',
        data: $.param(data),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
        .then(function success(successData) {
          resolve(successData);
        })
        .catch(function error(errorData) {
          reject(errorData.response.data.error);
        });
    });
  }

  static storeAccessToken(data) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.data.access_token;
    localStorage.setItem('access_token', data.data.access_token);
  }

  static rejectAccessToken(data) {
    if (data === 'not_registered') {
      router.push('/no-account');
    } else if (data === 'invalid_grant') {
      return 'Username, email, or password entered is incorrect.';
    } else {
      return 'An error has occured. Please refresh and try again.';
    }
  }

  static updateUser(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
    store.state[key] = data;
  }

  static logout(path) {
    axios.defaults.headers.common['Authorization'] = null;
    localStorage.clear();
    window.Intercom('shutdown');
    if (path === null || window.location.pathname === path) {
      window.location.reload(true);
    } else {
      window.location.pathname = path;
    }
  }

  static updateAccountInfoSuccess(data) {
    AuthService.updateUser('account', data);
  }

  static updateAccountInfoError(error) {
    return error;
  }

  static UpdateProfileInfoSuccess(data) {
    AuthService.updateUser('profile', data);
  }

  static UpdateProfileInfoError(error) {
    return error;
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.es6.js